import Joyride, { STATUS } from "react-joyride";
import { tours } from "../../Tours";
import { useTour } from "../../Hooks/useTour";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { store } from "../../Store/store";

const TourProvider = ({ tourName, userDetails }) => {
  const tourSteps = tours[tourName] || [];

  const { steps, stepIndex, handleRouteChange } = useTour(tourSteps);

  const ppTour = useSelector((state) => state.userData?.Pp_Tour);

  const isTourCompleted = localStorage.getItem(`tour_${tourName}`);

  // MAIN CONDITION
  const shouldRunTour = !isTourCompleted && !ppTour;

  const handleCallback = (data) => {
    const { status } = data;

    handleRouteChange(data);

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      localStorage.setItem(`tour_${tourName}`, "true");
      toast.success(
        `${tourName.charAt(0).toUpperCase() + tourName.slice(1)} Walkthrough Completed!`,
      );
    }
  };

  if (!steps.length) return null;

  return (
    <Joyride
      steps={steps}
      stepIndex={stepIndex}
      // run={!localStorage.getItem(`tour_${tourName}`)}
      run={shouldRunTour}
      continuous
      scrollToFirstStep
      showProgress
      showSkipButton
      callback={handleCallback}
      disableOverlayClose
      disableCloseOnEsc
      hideCloseButton
      styles={{
        options: {
          primaryColor: "#01994e",
          textColor: "#146930",
          zIndex: 1000,
        },
      }}
      locale={{ last: "Done" }}
    />
  );
};

export default TourProvider;
